
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {formatDate} from "@/auxillary/date-format";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'DateFieldReadonly',
  components: {
    OkDialog,
  },
})
export default class DateFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get formattedValue() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : formatDate(this?.dataField?.values?.value);
  }

  get value() {
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return this.displayName.length * 5;
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

}
